import { Button } from '@mm/components';
import { QuestionCircleIcon } from '@mm/icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { SlideoutMyGoals } from '../../editor/components/SlideoutMenu/menus/SlideoutMyGoals/SlideoutMyGoals';
import './HelpWidget.pcss';

type Props = {
  className?: string;
};

export const HelpWidget = ({ className }: Props) => {
  const [open, setOpen] = useState(false);
  const [ready, setReady] = useState(false);

  return (
    <div className={classNames(className, 'help-widget')}>
      <CSSTransitionGroup
        transitionName={{
          enter: 'help-widget__appear',
          enterActive: 'help-widget__appear-active',
          appear: 'help-widget__appear',
          appearActive: 'help-widget__appear-active',
        }}
        transitionAppear={true}
        transitionAppearTimeout={1000}
        transitionEnter={true}
        transitionEnterTimeout={1000}
        transitionLeave={false}
      >
        {!open && ready && (
          <Button
            color="purple"
            css={{ container: 'help-widget__button' }}
            onClick={() => setOpen(true)}
          >
            <QuestionCircleIcon color="white" />
          </Button>
        )}
      </CSSTransitionGroup>
      <SlideoutMyGoals
        visible={open}
        onClose={() => setOpen(false)}
        onReady={() => setReady(true)}
      />
    </div>
  );
};
